import { createAction } from '@reduxjs/toolkit';

import { withPayloadType } from 'utils';

export const sendResetPassEmailStart = createAction(
  'SEND_RESET_PASS_EMAIL::START',
  withPayloadType<{ email: string }>(),
);
